/*
 * Copyright (c) 2021. World Wide Generation Ltd
 */

import React from 'react';
import Header from '../../components/header';
import { Route, Switch } from 'react-router-dom';
import RouteErrorBoundary from '../../components/error/RouteErrorBoundary';
import { AppLayout } from '../../layout/AppLayout';
import { RouteInterface } from '../../types/routes';
import ProductPageContainer from '../../components/product-page/ProductPageContainer';
import { NotFound } from '../not-found/NotFound';

export const productsRouteEntry: RouteInterface = {
  id: 'products_entry',
  label: 'Products',
  path: '/products',
  exact: false,
  component: ProductsRoute
}

export const productsRoute: RouteInterface = {
  id: 'products',
  label: 'Products',
  path: '/products/:slug',
  exact: false,
  icon: 'fa-store',
  component: ProductPageContainer,
  auth: true,
}

/**
 * Product page entry point
 */
export function ProductsRoute() {


  return (
    <RouteErrorBoundary>
      <AppLayout className={'homeOverflow'} Header={<Route path={productsRoute.path} component={(props: any) => <Header {...props} />} />} >
        <Switch>
          <Route {...productsRoute} component={ProductPageContainer} />
          <Route>
            <NotFound />
          </Route>
        </Switch>
      </AppLayout>
    </RouteErrorBoundary>
  )
}

export default ProductPageContainer;

